define([
	"dojo/_base/declare",
	"csi",
	"csi/form/Widget",
	"csi/table/AggregateFrom",
	"./ContractualDocumentFormActionMixin"
], function(declare,csi,Widget,AggregateFrom,ContractualDocumentFormActionMixin) {

	return declare([ AggregateFrom, ContractualDocumentFormActionMixin ], {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set fixed field values based on context
			this.inherited(arguments);
			if (view.addDefaultValue) { // make sure we're on the form view
				var sourceObject = this.m_formData.getSelectedNode();
				this._initSourceObjectFormFields(view, sourceObject);
			}
		},

		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd) {
			this._adjustSaveScript(urlNode, fd);
			this.inherited(arguments);
		}
	});
});
